import React from 'react';
import ResultContent from 'components/reviewer/result/ResultContent';

export const ResultPage: React.FC = () => {
  return <ResultContent />;
};
